var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRight = function SvgIconRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33 33"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.394 17.92c.39 0 .759-.153 1.046-.478.554-.607.513-1.561-.062-2.147l-7.777-7.763a1.395 1.395 0 0 0-2.031.065c-.554.607-.513 1.561.061 2.147l7.778 7.763c.287.282.636.412.985.412"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.616 25.77c.35 0 .719-.13.985-.412l7.777-7.872c.575-.586.596-1.54.041-2.147a1.377 1.377 0 0 0-2.031-.044l-7.777 7.872a1.573 1.573 0 0 0-.041 2.147c.287.304.656.477 1.046.477z"
  })));
};
export default SvgIconRight;